import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { SmsSettingsResponse } from '../../../../models/responses/sms-settings-response';
import { AiAgentResponse } from '../../../../models/responses/ai-agent-response';
import { AiConfigurationPageEventsService } from '../../../../events/ai-configuration-page-events.service';
import { CALL_BACK_ICON } from '../../../../app.component';
import { CallBackSettingsResponse } from '../../../../models/responses/call-back-settings-response';
import { CallBackSettingsService } from '../../../../services/call-back-settings.service';

@Component({
  selector: 'app-call-back-setting-dialog',
  standalone: true,
  imports: [
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    NgFor,
    MatIconModule,
    MatDialogModule,
    AsyncPipe,
    MatSelectModule,
    ReactiveFormsModule,
    MatDividerModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatCheckboxModule,
    NgClass,
    NgIf
  ],
  templateUrl: './call-back-setting-dialog.component.html',
  styleUrl: './call-back-setting-dialog.component.scss'
})
export class CallBackSettingDialogComponent {
  callBackIcon = CALL_BACK_ICON
  isLoading = false;
  callBackSettingsForm!: FormGroup
  constructor(
    private formBuilder: FormBuilder,
    private callBackSettingsService: CallBackSettingsService,
    public dialogRef: MatDialogRef<CallBackSettingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { aiAgent: AiAgentResponse, callBackSetting: CallBackSettingsResponse },
    private aiConfigurationPageEventService: AiConfigurationPageEventsService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.callBackSettingsForm = this.formBuilder.group({
      condition: [this.data.callBackSetting ? this.data.callBackSetting.callBackCondition : '', Validators.required]
    })
  }
  onSubmit() {
    this.isLoading = true;

    const callBackCondition = this.callBackSettingsForm.value["condition"];

    if (this.data.callBackSetting) { 
      this.updateCallBackSetting(callBackCondition)
    } else {
      this.createCallBackSetting(callBackCondition);
    }

  }


  private createCallBackSetting(callBackCondition: any) {
    const request: CallBackSettingsResponse = {
      aiAgentId: this.data.aiAgent.id,
      callBackCondition: callBackCondition
    };

    this.callBackSettingsService.createCallBackSetting(request).subscribe({
      next: (callBackSetting) => {
        this.isLoading = false;
        this.aiConfigurationPageEventService.onCallBackSettingsAddedEvent.emit(callBackSetting);
        this.dialogRef.close();
      }, error: () => {
        alert("server error please contact support");
        this.isLoading = false;
      }
    });
  }

  private updateCallBackSetting(callBackCondition: any) {
    const request: CallBackSettingsResponse = {
      aiAgentId: this.data.aiAgent.id,
      callBackCondition: callBackCondition,
      id:this.data.callBackSetting.id
    };

    this.callBackSettingsService.updateCallBackSetting(request).subscribe({
      next: (callBackSetting) => {
        this.isLoading = false;
        this.aiConfigurationPageEventService.onCallBackSettingsAddedEvent.emit(callBackSetting);
        this.dialogRef.close();
      }, error: () => {
        alert("server error please contact support");
        this.isLoading = false;
      }
    });
  }
}
